import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";
import React from "react";
import EditPouleDialog from "../../components/structure/EditPouleDialog";
import { languages } from "../../constants/languages";
import poule36Min2Matches from "../../constants/Poule36-2Matches";
import poule36Min4Matches from "../../constants/Poule36-4Matches";
import poule36Matches from "../../constants/Poule36Matches";
import Poule3Matches from "../../constants/Poule3Matches";
import poule40Matches from "../../constants/Poule40Matches";
import Poule4Matches from "../../constants/Poule4Matches";
import Poule5Matches from "../../constants/Poule5Matches";
import Poule6Matches from "../../constants/Poule6Matches";
import { nextPouleName } from "../../util/NextPouleName";
import { getUploadErrorMessage } from "../../util/uploadErrors";
var robin = require("roundrobin");

class EditPouleContainer extends React.Component {
  state = {
    name: "",
    pouleSize: "4",
    scoreType: "default",
    numEncounters: 1,
    open: false,
    showOverwriteWarning: false,
    showLockMessage: false,

    showSponsor: false,
    sponsorName: "",
    sponsorLogoURL: "",
    isUploading: false,
    errorMessageSponsor: "",
    newSponsorLogo: false,

    // for HSSO
    numAbsent: 0,
  };

  UNSAFE_componentWillMount = () => {
    const poule = this.props.poule;
    if (poule) {
      this.updateState(poule);
    }
    if (this.props.singleMatch) {
      this.setState({ pouleSize: "2" });
    }
  };

  updateState = (poule) => {
    let numEncounters = 1;
    if (poule.doubleMatches) {
      numEncounters = 2;
    }
    numEncounters = poule.numEncounters || numEncounters;
    let newState = {
      name: poule.name || "",
      pouleSize: poule.pouleSize || "4",
      scoreType:
        poule.scoreType ||
        (this.props.belongsToBracket &&
        this.props.poule &&
        this.props.poule.bracket
          ? (this.props.bracketsByKey[this.props.poule.bracket] || {})[
              "scoreType"
            ]
          : false) ||
        ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
          this.props.division.id
        ] || {})[this.props.fase] ||
        "default",
      numEncounters: numEncounters,
      showSponsor: poule.showSponsor || false,
      sponsorName: poule.sponsorName || "",
      sponsorLogoURL: poule.sponsorLogoURL || "",
      numAbsent: poule.numAbsent || 0,
    };
    this.setState(newState);
  };

  handleShowSponsorChange = (event, checked) => {
    let newState = {};
    newState[event.target.name] = checked;
    this.setState(newState);
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  setScoreType = (scoreType) => {
    this.setState({ scoreType: scoreType });
  };

  handleNumEncountersChange = (event) => {
    const numEncounters = event.target.value;
    let newState = { showLockMessage: false, showOverwriteWarning: false };
    newState["numEncounters"] = Number(numEncounters);

    if (this.props.poule) {
      let currentNumEncounters = 1;
      if (this.props.poule.doubleMatches) {
        currentNumEncounters = 2;
      }
      currentNumEncounters =
        this.props.poule.numEncounters || currentNumEncounters;

      if (numEncounters !== currentNumEncounters) {
        if (this.props.tournament.scheduleLocked) {
          newState["showLockMessage"] = true;
        }
        newState["showOverwriteWarning"] = true;
      }
    }

    this.setState(newState);
  };

  handlePouleSizeChange = (event) => {
    const pouleSize = event.target.value;
    let showOverwriteWarning = false;
    let showLockMessage = false;
    if (this.props.poule && pouleSize !== this.props.poule.pouleSize) {
      (this.props.matches || []).forEach((match) => {
        if (match.field) {
          showOverwriteWarning = true;
        }
      });
      if (showOverwriteWarning) {
        if (this.props.tournament.scheduleLocked) {
          showLockMessage = true;
        }
      }
    }
    let toUpdate = {
      pouleSize: pouleSize,
      showOverwriteWarning: showOverwriteWarning,
      showLockMessage: showLockMessage,
    };
    if (Number(pouleSize) > 10 && this.state.numEncounters > 2) {
      toUpdate["numEncounters"] = 2;
    }
    this.setState(toUpdate);
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let tournamentVrsn = this.props.tournament.vrsn;
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      if (this.state.open) {
        this.toggleDialog();
      }
      const poule = {
        name: this.state.name,
        pouleSize: this.state.pouleSize,
        scoreType: this.state.scoreType,
        numEncounters: this.state.numEncounters,
        division: this.props.division.id,
        fase: this.props.fase,
        bracket: null,
        showSponsor: this.state.showSponsor,
        sponsorName: this.state.sponsorName,
        sponsorLogoURL: this.state.sponsorLogoURL,
      };

      if (
        (this.props.user.uid === "A1C3ztFFERMyFZlEKGrCEKCGRH03" || // HSSO
          this.props.user.uid === "dLIIgYris4QH9SaFvO1fYkfWhSw2" ||
          this.props.user.uid === "qwVXeKNiBzMz3RyUJSAJFLrkFnH2") &&
        this.state.pouleSize === "36"
      ) {
        poule["numAbsent"] = this.state.numAbsent;
      }

      if (this.props.singleMatch) {
        poule["singleMatch"] = true;
      }

      const db = window.firebase.firestore();
      let batch = db.batch();
      let matchesBatches = [];

      var pouleRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("poules");
      let pouleId = "";
      if (this.props.poule) {
        poule["bracket"] = this.props.poule.bracket || null;
        pouleRef = pouleRef.doc(this.props.poule.id);
        pouleId = this.props.poule.id;
        batch.update(pouleRef, poule);
        const teamsToMove = this.props.teams.filter(
          (team) =>
            team["numInPoule" + this.props.poule.fase] >=
              this.state.pouleSize &&
            team["numInPoule" + this.props.poule.fase] <
              this.props.poule.pouleSize &&
            !team.empty,
        );
        // console.log("teamsToMove", teamsToMove);
        for (let i in teamsToMove) {
          let teamsOrResultSpots = "teams";
          if (teamsToMove[i].resultSpot) {
            teamsOrResultSpots = "resultSpots";
          }
          let update = {};
          update["poule" + this.props.poule.fase] = null;
          batch.update(
            db
              .collection("tournaments")
              .doc(this.props.tournament[".key"])
              .collection(teamsOrResultSpots)
              .doc(teamsToMove[i].id),
            update,
          );
        }

        let currentNumEncounters = 1;
        if (this.props.poule.doubleMatches) {
          currentNumEncounters = 2;
        }
        currentNumEncounters =
          this.props.poule.numEncounters || currentNumEncounters;

        if (
          this.state.numEncounters !== currentNumEncounters ||
          this.state.pouleSize !== this.props.poule.pouleSize ||
          ((this.props.user.uid === "A1C3ztFFERMyFZlEKGrCEKCGRH03" || // HSSO
            this.props.user.uid === "dLIIgYris4QH9SaFvO1fYkfWhSw2" ||
            this.props.user.uid === "qwVXeKNiBzMz3RyUJSAJFLrkFnH2") &&
            this.state.pouleSize === "36" &&
            this.state.numAbsent !== this.props.poule.numAbsent)
        ) {
          matchesBatches = this.makeMatches(
            pouleRef.id,
            this.props.poule.bracket,
          );
          batch = this.makeResultSpots(batch, pouleRef.id);
        }
      } else {
        let lastNum = -1;
        let lastLetter = "";
        let lastNumOnline = -1;
        for (let i = 0; i < Object.keys(this.props.bracketsByKey).length; i++) {
          const bracket =
            this.props.bracketsByKey[Object.keys(this.props.bracketsByKey)[i]];
          if (bracket.num >= lastNum) {
            lastNum = bracket.num;
            lastLetter = bracket.letter;
          }
        }

        for (let i = 0; i < Object.keys(this.props.poulesByKey).length; i++) {
          const poule =
            this.props.poulesByKey[Object.keys(this.props.poulesByKey)[i]];
          if (poule.num > lastNum && !poule.bracket) {
            lastNum = poule.num;
            lastLetter = poule.letter;
            if (tournamentVrsn >= 6 && poule.numOnline !== undefined) {
              lastNumOnline = poule.numOnline;
            }
          }
        }

        poule["num"] = lastNum + 1;
        poule["letter"] = nextPouleName(lastLetter);
        if (tournamentVrsn >= 6) {
          poule["numOnline"] = lastNumOnline + 1;
        }
        poule["name"] =
          languages.structure.poule +
          " " +
          (this.props.tournament.online && tournamentVrsn >= 6
            ? (poule.numOnline + 1).toString()
            : poule.letter);
        if (this.props.singleMatch) {
          poule["name"] =
            languages.structure.matchCapital +
            " " +
            (this.props.tournament.online && tournamentVrsn >= 6
              ? (poule.numOnline + 1).toString()
              : poule.letter);
        }
        pouleRef = pouleRef.doc();
        pouleId = pouleRef.id;
        batch.set(pouleRef, poule);
        matchesBatches = this.makeMatches(pouleRef.id);
        batch = this.makeResultSpots(batch, pouleRef.id);
      }

      let mainBatches = [batch];
      let numInBatch = 0;

      if (this.props.poule) {
        const affectedPairs = new Set();
        // When there's a poule set in the props, also the matches for this poule are passed
        for (let x in this.props.matches) {
          const match = this.props.matches[x];
          if (match.field !== null && match.field !== undefined) {
            const dayId = match.day || "0";
            affectedPairs.add(`${match.field}__${dayId}`);
          }
        }
        affectedPairs.forEach((pair) => {
          const [fieldId, dayId] = pair.split("__");
          if (numInBatch >= 499) {
            batch = db.batch();
            mainBatches.push(batch);
            numInBatch = 0;
          }
          batch.set(db.collection("cacheUpdates").doc(), {
            tournamentId: this.props.tournament[".key"],
            fieldId,
            dayId,
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
          numInBatch++;
        });
      }
      if (this.props.tournament.ia) {
        if (numInBatch >= 499) {
          batch = db.batch();
          mainBatches.push(batch);
        }
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      Promise.all(matchesBatches.map((b) => b.commit())).then(() => {
        Promise.all(mainBatches.map((b) => b.commit())).then(() => {
          if (this.state.sponsorLogoURL && this.state.newSponsorLogo) {
            var httpsReference = window.firebase
              .app()
              .storage("gs://tournament-uploads/")
              .refFromURL(this.state.sponsorLogoURL);
            httpsReference
              .updateMetadata({
                customMetadata: {
                  sponsorType: "poules",
                  tournamentId: this.props.tournament[".key"],
                  elementId: pouleId,
                },
              })
              .catch(function (error) {
                // Uh-oh, an error occurred!
                console.log(error.message);
              });
          }
        });
      });
    }
  };

  makeMatches = (pouleId, bracketId) => {
    let batches = [];
    let teams = [];
    for (let i = 0; i < this.state.pouleSize; i++) {
      teams.push({
        id: i,
      });
    }
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");

    let rounds = robin(teams.length, teams);
    let useSpecialOrder = false;
    if (
      (this.props.user.uid === "A1C3ztFFERMyFZlEKGrCEKCGRH03" ||
        this.props.user.uid === "dLIIgYris4QH9SaFvO1fYkfWhSw2" ||
        this.props.user.uid === "qwVXeKNiBzMz3RyUJSAJFLrkFnH2") &&
      this.state.pouleSize === "40"
    ) {
      rounds = poule40Matches;
      useSpecialOrder = true;
    }
    if (
      (this.props.user.uid === "A1C3ztFFERMyFZlEKGrCEKCGRH03" ||
        this.props.user.uid === "dLIIgYris4QH9SaFvO1fYkfWhSw2" ||
        this.props.user.uid === "qwVXeKNiBzMz3RyUJSAJFLrkFnH2") &&
      this.state.pouleSize === "36"
    ) {
      rounds = poule36Matches;
      if (this.state.numAbsent === 2) {
        rounds = poule36Min2Matches;
      } else if (this.state.numAbsent === 4) {
        rounds = poule36Min4Matches;
      }
      useSpecialOrder = true;
    }
    if (this.state.pouleSize === "3") {
      rounds = Poule3Matches;
      useSpecialOrder = true;
    } else if (this.state.pouleSize === "4") {
      rounds = Poule4Matches;
      useSpecialOrder = true;
    } else if (this.state.pouleSize === "5") {
      rounds = Poule5Matches;
      useSpecialOrder = true;
    } else if (this.state.pouleSize === "6") {
      rounds = Poule6Matches;
      useSpecialOrder = true;
    }
    let numInBatch = 0;
    let batch = db.batch();
    let num = 0;
    let roundNum = 0;

    const numEncounters = this.state.numEncounters;

    [...Array(numEncounters)].forEach((_, encounterI) => {
      const evenEncounter = encounterI % 2 === 0;
      for (let i in rounds) {
        let round = rounds[i];
        for (let j in round) {
          let match = round[j];
          let newMatch = {
            round: roundNum,
            poule: pouleId,
            bracket: bracketId || null,
            numInPoule: num,
            team1: useSpecialOrder
              ? match[evenEncounter ? 0 : 1] - 1
              : match[evenEncounter ? 0 : 1].id,
            team2: useSpecialOrder
              ? match[evenEncounter ? 1 : 0] - 1
              : match[evenEncounter ? 1 : 0].id,
            score1: null,
            score2: null,
            field: null,
          };
          num++;
          const newRef = matchesRef.doc();
          batch.set(newRef, newMatch);
          numInBatch++;
          if (numInBatch > 499) {
            numInBatch = 0;
            batches.push(batch);
            batch = db.batch();
          }
        }
        roundNum++;
      }
    });

    // delete old matches
    if (this.props.matches) {
      for (let x in this.props.matches) {
        let oldMatch = this.props.matches[x];
        batch.delete(matchesRef.doc(oldMatch.id));
        numInBatch++;
        if (numInBatch > 499) {
          numInBatch = 0;
          batches.push(batch);
          batch = db.batch();
        }
      }
    }

    if (numInBatch > 0) {
      batches.push(batch);
    }
    return batches;
  };

  makeResultSpots = (batch, pouleId) => {
    const db = window.firebase.firestore();

    const resultSpotsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots");

    // delete old result spots
    if (this.props.resultSpotsNotDivided) {
      for (let x in this.props.resultSpotsNotDivided) {
        let oldResultSpot = this.props.resultSpotsNotDivided[x];
        batch.delete(resultSpotsRef.doc(oldResultSpot.id));
      }
    }

    for (let i = 0; i < this.state.pouleSize; i++) {
      let resultSpot = {
        fromPoule: pouleId,
        rank: i,
        type: 0,
        fase: this.props.fase,
        division: this.props.division.id,
      };
      let newRef = resultSpotsRef.doc();
      for (let x in this.props.resultSpotsNotDivided) {
        let oldResultSpot = this.props.resultSpotsNotDivided[x];
        if (oldResultSpot.rank === i) {
          resultSpot = oldResultSpot;
          newRef = resultSpotsRef.doc(oldResultSpot.id);
        }
      }

      batch.set(newRef, resultSpot);
    }

    return batch;
  };

  handleDeleteSponsor = () => {
    let toUpdate = { sponsorLogoURL: "", newSponsorLogo: false };
    this.setState(toUpdate);
    // let urlToDelete = this.state.sponsorLogoURL;

    // window.firebase
    //   .firestore()
    //   .collection("tournaments")
    //   .doc(this.props.tournament[".key"])
    //   .collection("poules")
    //   .doc(this.props.poule.id)
    //   .update(toUpdate);

    // var httpsReference = window.firebase
    //   .app()
    //   .storage("gs://tournament-uploads/")
    //   .refFromURL(urlToDelete);
    // httpsReference.delete().catch(function (error) {
    //   // Uh-oh, an error occurred!
    //   console.log(error.message);
    // });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "sponsors/" + this.props.user.uid + "/" + this.props.tournament[".key"],
      );
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessageSponsor: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessageSponsor: getUploadErrorMessage(error, 1) };
    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });
    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        let toUpdate = { sponsorLogoURL: url, newSponsorLogo: true };
        this.setState(toUpdate);
        // window.firebase
        //   .firestore()
        //   .collection("tournaments")
        //   .doc(this.props.tournament[".key"])
        //   .collection("sportParks")
        //   .doc(this.props.sportPark.id)
        //   .update(toUpdate);
      });
  };

  render() {
    let nameValid = this.state.name.length > 0 || !this.props.poule;
    let pouleSizeValid = this.state.pouleSize > 1 && this.state.pouleSize < 51;
    let numEncountersValid =
      this.state.numEncounters > 0 && this.state.numEncounters <= 10;
    if (Number(this.state.pouleSize) > 10 || this.props.belongsToBracket) {
      numEncountersValid =
        this.state.numEncounters > 0 && this.state.numEncounters <= 2;
    }

    let allowedToUpload = false;
    if (
      (this.props.tournamentStatus || {}).status === 1 ||
      (this.props.tournamentStatus || {}).status === 2 ||
      (this.props.tournamentStatus || {}).status === 3 ||
      (this.props.userStatus || {}).status === 1 ||
      (this.props.userStatus || {}).status === 2 ||
      (this.props.userStatus || {}).status === 3
    ) {
      allowedToUpload = true;
    }

    let scoreType = this.state.scoreType;
    if (scoreType !== "default") {
      if ((this.props.tournament.scoringTypes || {})[scoreType] === undefined) {
        scoreType = "default";
      }
    }

    return (
      <div>
        {this.state.open && (
          <EditPouleDialog
            toggleDialog={this.toggleDialog}
            handleChange={this.handleChange}
            handlePouleSizeChange={this.handlePouleSizeChange}
            handleSubmit={this.handleSubmit}
            poule={this.props.poule}
            {...this.state}
            division={this.props.division}
            fase={this.props.fase}
            scoreType={scoreType}
            setScoreType={this.setScoreType}
            nameValid={nameValid}
            pouleSizeValid={pouleSizeValid}
            numEncountersValid={numEncountersValid}
            handleNumEncountersChange={this.handleNumEncountersChange}
            singleMatch={this.props.singleMatch}
            belongsToBracket={this.props.belongsToBracket}
            tournament={this.props.tournament}
            allowedToUpload={allowedToUpload}
            toggleUpgradeDialog={this.props.toggleUpgradeDialog}
            user={this.props.user}
            // sponsor
            handleShowSponsorChange={this.handleShowSponsorChange}
            sponsorStorageRef={this.getStorageRef()}
            handleDeleteSponsor={this.handleDeleteSponsor}
            handleUploadStart={this.handleUploadStart}
            handleProgress={this.handleProgress}
            handleUploadError={this.handleUploadError}
            handleUploadSuccess={this.handleUploadSuccess}
            errorMessageSponsor={this.state.errorMessageSponsor}
            isUploadingSponsor={this.state.isUploading}
          />
        )}
        {this.props.poule ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            style={{
              color: "white",
              width: 20,
              height: 20,
              marginRight:
                this.props.belongsToBracket && !this.props.poule.losersFinal
                  ? 5
                  : 0,
            }}
          >
            <CreateIcon style={{ height: 20, position: "absolute", top: 2 }} />
          </IconButton>
        ) : (
          <Button
            size="small"
            variant="outlined"
            color="default"
            onClick={
              this.props.singleMatch ? this.handleSubmit : this.toggleDialog
            }
            style={{ width: 220 }}
          >
            <AddIcon style={{ height: 16, width: 16 }} />
            {this.props.singleMatch
              ? languages.structure.singleMatch
              : languages.structure.poule}
          </Button>
        )}
      </div>
    );
  }
}

export default EditPouleContainer;
